import React from "react";
import "./Testimonials.css";

const Testimonials = () => {
  const feedbacks = [
    {
      id: 1,
      message:
        "I enjoyed the learning experience with Polymath-Kids-Abacus. The teacher was very friendly. I highly recommend Polymath-Kids-Abacus.",
      name: "Mujtaba Khawaja Sahaf",
      age: 12,
    },
    {
      id: 2,
      message:
        "I feel so proud when my class fellows call me ’BRAINIAC’, because I can effortlessly do mental calculations much faster and accurate than my classmates. Thank you Polymath-Kids.",
      name: "Wahaab Omer",
      age: 12,
    },
    {
      id: 3,
      message:
        "I am very happy now, I am Elina Kumari, 7 years and study in class 2 but I am super fast in math in my class. I earn every week new star in class. I want to thank you Polymath-kids for teaching me ABACUS. I am enjoying it very much.",
      name: "Elina Kumari",
      age: 7,
    },
    {
      id: 4,
      message:
        "Mental maths course is a good source of brain stimular for kids. My son participates fully in class and enjoys the planned activities. I personally like the Anzan Do it in head activities, though my son enjoys other ones more These do it in your head activities enable me to judge my son's progress better. Teacher encourages kids a lot even when they make mistakes, get answers wrong, or are unable to answer at all. This course is not only instilling in kids the sense of competition but also how to be a good team player.",
      name: "Saadia Aftab M/O Khawaja Haroon",
      age: 5,
    },
    {
      id: 5,
      message:
        "Abacus is fun to learn and it helps me to calculate big numbers easily. I can do addition and subtraction more quickly.",
      name: "Eman Omer",
      age: 10,
    },
    {
      id: 6,
      message:
        "The abacus program helped in my math classes at school. It made me feel confident in my work. Also it helped me become a more focused student in all my classes. I enjoyed learning from my abacus teacher. She's very nice and encouraging.",
      name: "MUSTAFA SALEEM BHATTI",
      age: 9,
    },
    {
      id: 7,
      message:
        "Quite a wonderful Learning experience. Really enjoying the classes with best teacher ever!!",
      name: "Abdul Hadi",
      age: 10,
    },
    {
      id: 8,
      message:
        "The Adobe Photoshop course was fun and helpful. The content was amazing. It is very good for earning money and doing freelancing. ",
      name: "Minahil Jahanzeb",
      age: 12,
    },
    {
      id: 9,
      message:
        "Ayesha experience had of great summer camp. It was very well planned and executed. Well done to your team. I am impressed beyond expectations.",
      name: "Zahra Umair M/O Ayesha Amad",
      age: 15,
    },
    {
      id: 10,
      message:
        "Polymath-Kids has been a game-changer for my daughter’s interest in technology! She has been exploring the world of web coding, and I am amazed at how much she has learned in such a short time. The instructors are not only knowledgeable but also incredibly encouraging, which has helped her stay motivated and excited about coding. The admin team has also been fantastic, ensuring everything runs smoothly. I highly recommend Polymath-Kids to any parent looking to nurture their child’s passion for coding!",
      name: "Amal Malik",
      age: 15,
    },
    // {
    //   id: 11,
    //   message:
    //     "I enjoy math a lot more since I joined Polymath-Kids-Abacus. The methods they teach are so effective.",
    //   name: "Aiman Noor",
    //   age: 10,
    // },
    {
      id: 11,
      message:
        "I am thrilled with the progress my son has made since joining Polymath-Kids! The mental math program has been nothing short of amazing. He has not only improved his calculation speed but has also developed a newfound confidence in tackling math problems. The instructors are incredibly patient and skilled at breaking down complex concepts into easy-to-understand lessons. What I love most is how engaging and fun the classes are—my son actually looks forward to learning!",
      name: "Haris Malik",
      age: 13,
    },
    {
      id: 12,
      message:
        "Thank you, Polymath-Kids, for the wonderful experience for my son Carl. A special mention to his teacher, Ms. Aleesha. Thank you, teacher, for everything-my son learned so much from you. You boosted his confidence, especially in speaking. I hope he will continue learning from you, ma'am.",
      name: "Carl Adrianne Silvio",
      age: 8,
    },
    {
      id: 13,
      message:
        "The summer class at Polymath-Kids was fantastic for my son! He learned so much, from basic programming using Scratch and Tynker to designing with Canva. He also picked up the skill of using an abacus, which was amazing to see. He really enjoyed the classes and looked forward to them every day. It was definitely worth it, and I’m so grateful to all the teachers for their dedication and effort. More power to Polymath-Kids!",
      name: "Paula Jammarie Santos",
      age: 10,
    },
    {
      id: 14,
      message:
        "My daughter had an incredible experience at Polymath-Kids this summer! She learned a variety of skills, including programming with Scratch and Tynker, designing on Canva, and even using an abacus. She absolutely loved the classes and was always excited to share what she learned each day. It was such a worthwhile experience, and I’m so thankful to all the teachers for their hard work and support. More power to Polymath-Kids!",
      name: "Paula Jammarie Santos",
      age: 8,
    },
  ];

  return (
    <div className="backgroundtest" id="testimonial">
      <div className="row" style={{ width: "100%" }}>
        <div className="col-lg-8 mx-auto">
          <h2
            className="Testimonial_Heading"
            style={{
              color: "#333",
              textAlign: "center",
              textTransform: "uppercase",
              fontFamily: '"Roboto", sans-serif',
              fontWeight: "bold",
              position: "relative",
              margin: "5px 0 30px",
            }}
          >
            Testimonials
          </h2>
          <div id="myCarousel" className="carousel slide" data-ride="carousel">
            {/* Carousel indicators */}
            <ol className="carousel-indicators">
              {feedbacks.map((_, index) => (
                <li
                  key={index}
                  data-target="#myCarousel"
                  data-slide-to={index}
                  className={index === 0 ? "active" : ""}
                ></li>
              ))}
            </ol>

            {/* Carousel items */}
            <div className="carousel-inner">
              {feedbacks.map((feedback, index) => (
                <div
                  key={feedback.id}
                  className={`carousel-item ${index === 0 ? "active" : ""}`}
                >
                  <div className="imge-box">
                    <div className={`imge-box${index + 1}`}></div>
                  </div>
                  <p
                    className="testimonial"
                    style={{ color: "black", fontSize: "2.5vh" }}
                  >
                    {feedback.message}
                  </p>
                  <p style={{ color: "#ff7d00", fontSize: "3vh" }}>
                    <b>{feedback.name}</b>
                    {feedback.age && `, Age ${feedback.age} Years`}
                  </p>
                </div>
              ))}
            </div>

            {/* Carousel controls */}
            <a
              className="carousel-control-prev"
              href="#myCarousel"
              role="button"
              data-slide="prev"
            >
              <i className="fa fa-angle-left"></i>
            </a>
            <a
              className="carousel-control-next"
              href="#myCarousel"
              role="button"
              data-slide="next"
            >
              <i className="fa fa-angle-right"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
